export default __webpack_public_path__ + "static/media/map-2.e455ada6.png";